<template>
  <div class="card-body pt-0 edge-to-edge" v-if="$gate.isAdmin()">
    <div id="tabel_facturare_wrapper" style="position: relative;">
      <div class="table-responsive">
        <table class="table table-bordered table-striped" role="grid" id="tabel_facturare">
          <thead>
            <tr class="text-uppercase fw-bold">
              <th class="text-center" style="width:32px">
                <div class="form-check form-check-custom form-check-success form-check-solid d-inline-flex">
                  <input class="form-check-input" type="checkbox" :checked="selectAllVisibleChecked"
                    @change="onToggleSelectAllVisible($event)" />
                </div>
              </th>
              <th style="width: 50px;">ID</th>
              <th style="width: 30px;"></th>
              <th style="width: 100px;">Data</th>
              <th style="width: 100px;">Nr. doc.</th>
              <th style="min-width: 200px;">Client</th>
              <th style="width: 100px;" class="text-end">Valoare</th>
              <th style="width: 90px;" class="text-end">TVA</th>
              <th style="width: 110px;" class="text-end">Total</th>
              <th style="width: 100px;">Stare</th>
              <th style="width: 100px;" class="text-end">Sold</th>
              <th style="width: 90px;">Scadență</th>
              <th style="width: 60px;" class="text-center">TVA-I</th>
              <th style="width: 90px;">e-Fact</th>
              <th style="width: 50px;" class="text-center">RJ</th>
              <th style="width: 80px;" class="text-center">Acțiuni</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="factura in facturi" :key="factura.id">
              <tr :class="`row-factura-${factura.id}`">
                <td class="text-center">
                  <div class="form-check form-check-custom form-check-success form-check-solid d-inline-flex">
                    <input class="form-check-input row-select" type="checkbox" :checked="isSelected(factura.id)"
                      @change="onToggleSelect(factura.id, $event)" />
                  </div>
                </td>
                <td>{{ factura.id }}</td>
                <td class="details-control text-center" style="cursor: pointer;" @click="toggleFacturaDetails(factura)">
                  <i class="fas fa-chevron-down" :class="{ 'rotate-up': expandedRows.includes(factura.id) }"></i>
                </td>
                <td>{{ formatDate(factura.data_doc) || '/' }}</td>
                <td :data-order="Number(factura.nr_doc) || 0">
                  {{ factura.sd_serie }}{{ factura.nr_doc }}
                </td>
                <td>
                  <div style="position: relative;">
                    <div class="text-truncate-clickable"
                      @click.stop="showFullName(factura.c_denumire, 'client_' + factura.id)"
                      :title="factura.c_denumire">
                      {{ factura.c_denumire || '/' }}
                    </div>
                    <!-- Tooltip nested -->
                    <div v-if="tooltipData.visible && tooltipData.activeId === 'client_' + factura.id"
                      class="custom-table-tooltip">
                      {{ tooltipData.text }}
                    </div>
                  </div>
                </td>
                <td class="text-end">{{ formatMoney(factura.iesiri_date_valoare) }}</td>
                <td class="text-end">{{ formatMoney(factura.iesiri_date_tva) }}</td>
                <td class="text-end" :class="Number(factura.iesiri_date_total) < 0 ? 'text-danger fw-bold' : ''">
                  {{ formatMoney(factura.iesiri_date_total) }}
                </td>
                <td>
                  <div class="progress h-30px">
                    <div class="progress-bar progress-bar-striped progress-bar-animated text-white fw-bold fs-6 py-2"
                      :class="{
                        'bg-danger': Number(factura.stare) === 0 || factura.stare === null || factura.stare === undefined,
                        'bg-warning': Number(factura.stare) === 1,
                        'bg-success': Number(factura.stare) === 2
                      }" role="progressbar" :style="{
                        width: (Number(factura.stare) === 0 || factura.stare === null || factura.stare === undefined) ? '100%' : (Number(factura.stare) === 1 ? '75%' : '100%')
                      }"
                      :aria-valuenow="(Number(factura.stare) === 0 || factura.stare === null || factura.stare === undefined) ? 100 : (Number(factura.stare) === 1 ? 75 : 100)"
                      aria-valuemin="0" aria-valuemax="100">
                      {{ (Number(factura.stare) === 0 || factura.stare === null || factura.stare === undefined) ?
                        'Restant' : (Number(factura.stare) === 1 ? 'Achitat parțial' : 'Achitat') }}
                    </div>
                  </div>
                </td>
                <td class="text-end fw-bold" :class="Number(factura.sold_factura) > 0 ? 'text-danger' : 'text-success'">
                  {{ formatMoney(factura.sold_factura) }}
                </td>
                <td>{{ formatDate(factura.data_scadenta) || '/' }}</td>
                <td class="text-center">
                  <div
                    class="form-check form-check-custom form-check-success form-check-solid d-inline-flex align-items-center mb-0">
                    <input class="form-check-input" type="checkbox" :checked="!!factura.tva_incasare" disabled />
                  </div>
                </td>
                <td>
                  <div v-if="Number(factura.anaf_ft_status) === 1" class="progress h-30px efact-clickable"
                    @click="showEFactPopup(factura, 'upload')">
                    <div class="progress-bar progress-bar-striped progress-bar-animated text-white fw-bold fs-7 py-1"
                      :class="eFactUploadBarClass(factura.anaf_ft_stare_upload)" role="progressbar"
                      :style="{ width: '100%' }" :aria-valuenow="100" aria-valuemin="0" aria-valuemax="100">
                      {{ eFactUploadBarLabel(factura.anaf_ft_stare_upload) }}
                    </div>
                  </div>
                  <div v-else class="progress h-30px efact-clickable" @click="showEFactPopup(factura, 'status')">
                    <div class="progress-bar progress-bar-striped progress-bar-animated text-white fw-bold fs-7 py-1"
                      :class="eFactStatusBarClass(factura.anaf_ft_status)" role="progressbar" :style="{ width: '100%' }"
                      :aria-valuenow="100" aria-valuemin="0" aria-valuemax="100">
                      {{ eFactStatusBarLabel(factura.anaf_ft_status) }}
                    </div>
                  </div>
                </td>
                <td class="text-center">
                  <span v-if="factura.rj_id" class="text-success" title="Înregistrare existentă">✅</span>
                  <span v-else class="text-danger" title="Fără înregistrare">❌</span>
                </td>
                <td class="text-center">
                  <button type="button" class="btn btn-icon btn-sm btn-light-primary" title="Editează factură"
                    @click.stop="openRJModal(factura, true)">
                    <i class="fa-solid fa-pen-to-square"></i>
                  </button>
                  <button type="button" class="btn btn-icon btn-sm btn-light-info ms-1"
                    @click.stop="openRJModal(factura, false)" title="Registru jurnal">
                    <i class="fa-solid fa-book"></i>
                  </button>
                  <button type="button" class="btn btn-icon btn-sm btn-light-success ms-1"
                    @click.stop="deschideIncasare(factura)" title="Încasează">
                    <i class="fa-solid fa-money-bill-wave"></i>
                  </button>
                  <button type="button" class="btn btn-icon btn-sm btn-light-danger ms-1"
                    @click.stop="stergeFactura(factura)" title="Șterge factura">
                    <i class="fa-solid fa-trash"></i>
                  </button>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </div>


    <!-- Tooltip custom removed from here, now nested -->

    <!-- Modal/popup simplu pentru e-Fact -->
    <div v-if="efactPopup.visible" class="modal-backdrop" @click="efactPopup.visible = false">
      <div class="modal-card" @click.stop>
        <div class="modal-header">
          <h5 class="modal-title">{{ efactPopup.title }}</h5>
          <button type="button" class="btn-close" @click="efactPopup.visible = false">×</button>
        </div>
        <div class="modal-body" v-html="efactPopup.message"></div>
      </div>
    </div>

    <!-- Modal Registru Jurnal - Facturi emise (Bootstrap modal) -->
    <div class="modal fade" id="lucruModalFacturiEmise" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-xl modal-xxl-custom modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Lucru pe factură</h5>
            <button type="button" class="btn-close" aria-label="Close" @click="closeRJModal"></button>
          </div>
          <div class="modal-body">
            <div v-if="rjLoading">
              <p>Se încarcă datele din registrul jurnal...</p>
            </div>
            <div v-else class="row g-4">
              <!-- LEFT: Detalii factură + Produse -->
              <div class="col-12 col-xl-6">
                <!-- FILE PREVIEW -->
                <div v-if="filePreview" class="mb-3">
                  <div class="fs-6 text-muted mb-2">
                    <i class="fa-solid fa-file-image me-1"></i> Fișier sursă: {{ filePreview.original_name }}
                  </div>
                  <div class="border rounded overflow-hidden bg-white file-preview-container">
                    <img v-if="filePreview.is_image"
                      :src="`/api/administrare/work/fisiere/stream_iesire/${filePreview.file_id}?firma_id=${firmaId}`"
                      class="img-fluid w-100" alt="Preview factură" style="max-height: 350px; object-fit: contain;" />
                    <iframe v-else-if="filePreview.is_pdf"
                      :src="`/api/administrare/work/fisiere/stream_iesire/${filePreview.file_id}?firma_id=${firmaId}`"
                      class="w-100" style="height: 350px; border: none;"></iframe>
                    <div v-else class="p-3 text-center text-muted">
                      <i class="fa-solid fa-file fa-2x mb-2"></i>
                      <div>{{ filePreview.original_name }}</div>
                    </div>
                  </div>
                </div>

                <!-- Toggle button -->
                <div class="d-flex align-items-center mb-3">
                  <button type="button" class="btn btn-sm me-2" :class="editMode ? 'btn-light-primary' : 'btn-primary'"
                    @click="editMode = false">
                    <i class="fa-solid fa-eye me-1"></i> Vizualizare
                  </button>
                  <button type="button" class="btn btn-sm" :class="editMode ? 'btn-primary' : 'btn-light-primary'"
                    @click="activateEditMode">
                    <i class="fa-solid fa-pen-to-square me-1"></i> Editare
                  </button>
                </div>

                <!-- VIEW MODE -->
                <div v-if="!editMode">
                  <div v-if="modalFactura">
                    <div class="mb-4">
                      <div class="fs-6 text-muted mb-2">Detalii factură</div>
                      <div class="border rounded p-3 bg-light">
                        <div class="row mb-2">
                          <div class="col-5 text-muted">ID</div>
                          <div class="col-7">{{ modalFactura?.id ?? '-' }}</div>
                        </div>
                        <div class="row mb-2">
                          <div class="col-5 text-muted">Serie / Nr.</div>
                          <div class="col-7">
                            {{ (modalFactura?.sd_serie || modalFactura?.serie_doc || '') + (modalFactura?.nr_doc || '')
                            }}
                          </div>
                        </div>
                        <div class="row mb-2">
                          <div class="col-5 text-muted">Data</div>
                          <div class="col-7">{{ formatDate(modalFactura?.data_doc) || '-' }}</div>
                        </div>
                        <div class="row mb-2">
                          <div class="col-5 text-muted">Data eFactura</div>
                          <div class="col-7">{{ $filters.formatDate(modalFactura?.afp_data_creare) || '-' }}</div>
                        </div>
                        <div class="row mb-2">
                          <div class="col-5 text-muted">Client</div>
                          <div class="col-7">{{ modalFactura?.c_denumire || '-' }}</div>
                        </div>
                        <div class="row mb-2">
                          <div class="col-5 text-muted">Valoare / TVA / Total</div>
                          <div class="col-7">
                            {{ formatMoney(modalFactura?.iesiri_date_valoare) }} /
                            {{ formatMoney(modalFactura?.iesiri_date_tva) }} /
                            {{ formatMoney(modalFactura?.iesiri_date_total) }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div>
                      <div class="d-flex align-items-center mb-2">
                        <div class="fs-6 text-muted me-2">Produse</div>
                        <div v-if="modalLoading" class="spinner-border spinner-border-sm" role="status">
                          <span class="visually-hidden">Loading...</span>
                        </div>
                      </div>
                      <div class="modal-products-scroll border rounded">
                        <table class="table table-sm table-striped align-middle mb-0">
                          <thead>
                            <tr>
                              <th>#</th>
                              <th>Denumire</th>
                              <th class="text-end">Cant.</th>
                              <th class="text-end">Preț</th>
                              <th class="text-end">Valoare</th>
                              <th class="text-end">TVA</th>
                              <th class="text-end">Total</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-if="!modalLoading && (!modalProduse || modalProduse.length === 0)">
                              <td colspan="7" class="text-center text-muted py-4">
                                Nu există produse pentru această factură.
                              </td>
                            </tr>
                            <tr v-for="(p, idx) in modalProduse" :key="`p_${idx}`">
                              <td>{{ idx + 1 }}</td>
                              <td>{{ productName(p) }}</td>
                              <td class="text-end">{{ productQty(p) }}</td>
                              <td class="text-end">{{ productPrice(p) }}</td>
                              <td class="text-end">{{ productValue(p) }}</td>
                              <td class="text-end">{{ productTva(p) }}</td>
                              <td class="text-end">{{ productTotal(p) }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div v-else class="text-muted">
                    Nu există detalii de factură de afișat.
                  </div>
                </div>

                <!-- EDIT MODE -->
                <div v-else>
                  <div v-if="facturaUtilsLoading" class="text-center p-5">
                    <div class="spinner-border text-primary" role="status"></div>
                    <p class="mt-2 text-muted">Se încarcă editorul...</p>
                  </div>
                  <div v-else>
                    <AdaugaFactura_Iesire v-model="facturaForm" v-model:produse="facturaProduse"
                      :serii-facturi="seriiFacturi" :lista-clienti="listaClienti" :valute="valute"
                      :unitati-masura="unitatiMasura" :tipuri-produse="tipuriProduse" :plan-conturi="planConturi"
                      :cote-tva="coteTva" :firma-id="firmaId">
                    </AdaugaFactura_Iesire>
                    <div class="d-flex justify-content-end mt-3">
                      <button type="button" class="btn btn-success fw-bold" @click="salveazaFacturaActualizata"
                        :disabled="facturaUtilsLoading">
                        <i class="fa-solid fa-check-double me-1"></i>
                        Actualizează factura
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <!-- RIGHT: RJ form -->
              <div class="col-12 col-xl-6">
                <div class="d-flex align-items-center justify-content-between mb-2">
                  <div class="fs-6 text-muted">Înregistrare contabilă (RJ)</div>
                  <span v-if="rjExists" class="badge bg-success">Înregistrare existentă</span>
                  <span v-else class="badge bg-secondary">Nouă, nesalvată în RJ</span>
                </div>

                <form @submit.prevent="submitRJ" autocomplete="off">
                  <div v-if="rjErrors && rjErrors.length" class="alert alert-danger py-2">
                    <ul class="mb-0 ps-4">
                      <li v-for="(err, idx) in rjErrors" :key="`rj_err_${idx}`">{{ err }}</li>
                    </ul>
                  </div>

                  <div class="row g-3">
                    <div class="col-12">
                      <div class="form-check form-switch">
                        <input class="form-check-input" type="checkbox" id="switchAutoRJEmis" v-model="useAutoRJ" />
                        <label class="form-check-label" for="switchAutoRJEmis">
                          Postare automată (2 linii: 4111 → 707 &amp; 4427)
                        </label>
                      </div>
                    </div>

                    <div class="col-12 col-md-4">
                      <label class="form-label">Tip document</label>
                      <multiselect v-model="tipDocObj" :options="tipuriDocument" track-by="id" label="descriere"
                        placeholder="Alege tip" :show-labels="false" :allow-empty="false">
                      </multiselect>
                    </div>
                    <div class="col-12 col-md-4">
                      <label class="form-label">Data document</label>
                      <input type="date" class="form-control" v-model="rjForm.data_doc" />
                    </div>
                    <div class="col-12 col-md-4">
                      <label class="form-label">Observații</label>
                      <input type="text" class="form-control" v-model="rjForm.observatii"
                        placeholder="Notițe interne" />
                    </div>

                    <div class="col-12">
                      <label class="form-label">Client</label>
                      <input type="text" class="form-control" :value="modalFactura?.c_denumire || '-'" disabled />
                    </div>

                    <!-- ID-uri informative (readonly) -->
                    <div class="col-12 col-md-4">
                      <label class="form-label text-muted small">ID Client</label>
                      <input type="text" class="form-control form-control-sm bg-light"
                        :value="modalFactura?.id_client || '-'" readonly />
                    </div>
                    <div class="col-12 col-md-4">
                      <label class="form-label text-muted small">ID Client RJ</label>
                      <input type="text" class="form-control form-control-sm bg-light" :value="contClientCod || '-'"
                        readonly />
                    </div>
                    <div class="col-12 col-md-4">
                      <label class="form-label text-muted small">ID Furnizor RJ</label>
                      <input type="text" class="form-control form-control-sm bg-light" value="-" readonly />
                    </div>

                    <!-- Mesaj dacă deja înregistrat în RJ -->
                    <div v-if="rjExists" class="col-12">
                      <div class="alert alert-info py-2 mb-0">
                        <i class="fa-solid fa-circle-check me-2"></i>
                        <strong>Deja înregistrat în RJ.</strong> Poți vizualiza sau modifica înregistrarea existentă.
                      </div>
                    </div>

                    <div class="col-12 col-md-4">
                      <label class="form-label">Monedă</label>
                      <select class="form-select" v-model="rjForm.moneda">
                        <option value="RON">RON</option>
                        <option value="EUR">EUR</option>
                        <option value="USD">USD</option>
                      </select>
                    </div>
                    <div class="col-12 col-md-4">
                      <label class="form-label">Curs</label>
                      <input type="number" step="0.0001" class="form-control text-end" v-model.number="rjForm.curs"
                        :readonly="rjForm.moneda === 'RON'" />
                    </div>
                    <div class="col-12 col-md-2">
                      <label class="form-label">Serie</label>
                      <input type="text" class="form-control" v-model="rjForm.serie_doc"
                        :placeholder="modalFactura?.sd_serie || ''" />
                    </div>
                    <div class="col-12 col-md-2">
                      <label class="form-label">Nr.</label>
                      <input type="text" class="form-control" v-model="rjForm.nr_doc"
                        :placeholder="modalFactura?.nr_doc || ''" />
                    </div>

                    <div class="col-12 col-md-4">
                      <label class="form-label">Bază</label>
                      <input type="number" step="0.01" class="form-control text-end"
                        v-model.number="rjForm.valoare_baza" />
                    </div>
                    <div class="col-12 col-md-4">
                      <label class="form-label">TVA</label>
                      <input type="number" step="0.01" class="form-control text-end"
                        v-model.number="rjForm.valoare_tva" />
                    </div>
                    <div class="col-12 col-md-4">
                      <label class="form-label">Total</label>
                      <input type="number" step="0.01" class="form-control text-end"
                        v-model.number="rjForm.valoare_total" />
                    </div>

                    <!-- Previzualizare pentru modul AUTO -->
                    <div v-if="useAutoRJ" class="col-12">
                      <label class="form-label fw-bold">Linii contabile (AUTO — previzualizare)</label>
                      <table class="table table-sm table-bordered align-middle mb-1">
                        <thead>
                          <tr>
                            <th>Debit</th>
                            <th>Credit</th>
                            <th class="text-end">Sumă</th>
                            <th>Explicație</th>
                          </tr>
                        </thead>
                        <tbody>
                          <!-- Dacă există deja înregistrare RJ, afișăm liniile salvate -->
                          <template v-if="rjExists && liniiRJ.length > 0">
                            <tr v-for="(r, i) in liniiRJ" :key="`saved_${i}`">
                              <td>{{ r.cont_debit }}</td>
                              <td>{{ r.cont_credit }}</td>
                              <td class="text-end">
                                {{ Number(r.suma).toLocaleString('ro-RO', {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2
                                }) }}
                              </td>
                              <td>{{ r.explicatie }}</td>
                            </tr>
                          </template>
                          <!-- Altfel, afișăm previzualizarea generată automat -->
                          <template v-else>
                            <tr v-if="autoPreviewLines.length === 0">
                              <td colspan="4" class="text-center text-muted py-3">
                                Completează valorile pentru a vedea previzualizarea.
                              </td>
                            </tr>
                            <tr v-for="(r, i) in autoPreviewLines" :key="`auto_${i}`">
                              <td>{{ r.debit }}</td>
                              <td>{{ r.credit }}</td>
                              <td class="text-end">
                                {{ Number(r.suma).toLocaleString('ro-RO', {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2
                                }) }}
                              </td>
                              <td>{{ r.explicatie }}</td>
                            </tr>
                          </template>
                        </tbody>
                      </table>
                      <small class="text-muted">
                        <template v-if="rjExists && liniiRJ.length > 0">
                          * Linii deja salvate în registrul jurnal.
                        </template>
                        <template v-else>
                          * Previzualizare informativă — la salvare se vor posta liniile generate automat.
                        </template>
                      </small>
                    </div>

                    <!-- Repeater pentru modul MANUAL -->
                    <div v-if="!useAutoRJ" class="col-12">
                      <label class="form-label fw-bold">Linii contabile</label>
                      <table class="table table-sm table-bordered align-middle">
                        <thead>
                          <tr>
                            <th>Debit</th>
                            <th>Credit</th>
                            <th style="width:160px" class="text-end">Sumă</th>
                            <th>Explicație</th>
                            <th style="width:48px"></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(linie, idx) in liniiRJ" :key="`rj_${idx}`">
                            <td>
                              <input type="text" class="form-control" v-model="linie.cont_debit"
                                placeholder="ex: 4111.26" />
                            </td>
                            <td>
                              <input type="text" class="form-control" v-model="linie.cont_credit"
                                placeholder="ex: 707 sau 4427" />
                            </td>
                            <td>
                              <input type="number" step="0.01" class="form-control text-end"
                                v-model.number="linie.suma" />
                            </td>
                            <td>
                              <input type="text" class="form-control" v-model="linie.explicatie"
                                placeholder="Explicație" />
                            </td>
                            <td class="text-center">
                              <button type="button" class="btn btn-sm btn-light-danger" @click="liniiRJ.splice(idx, 1)">
                                <i class="fa-solid fa-trash"></i>
                              </button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <button type="button" class="btn btn-light-primary btn-sm"
                        @click="liniiRJ.push({ cont_debit: '', cont_credit: '', suma: 0, explicatie: '' })">
                        <i class="fa-solid fa-plus"></i> Adaugă linie
                      </button>
                      <small class="text-muted ms-2">
                        Sfat: asigură-te că totalul debitelor = totalul creditelor.
                      </small>
                    </div>

                    <div class="col-12 d-flex justify-content-end gap-2">
                      <button type="button" class="btn btn-light" @click="resetRJ">
                        Reset
                      </button>
                      <button type="submit" class="btn btn-primary" :disabled="rjSaving">
                        <span v-if="rjSaving" class="spinner-border spinner-border-sm me-2" role="status"
                          aria-hidden="true"></span>
                        Salvează RJ
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-light" @click="closeRJModal">Închide</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Incasare Factura -->
    <IncasareModal v-if="incasareModal.visible" :factura="incasareModal.factura" :firmaId="firmaId"
      :clientId="incasareModal.clientId" :allowAccountingEdit="true" @close="incasareModal.visible = false"
      @saved="loadFacturi()" />


  </div>
</template>

<script>
import { createApp } from 'vue';
import axios from 'axios';
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.css';
import FacturaChild from './Iesiri_FacturaChild.vue';
import IncasareModal from '../../Facturare/Iesiri/Facturi/IncasareModal.vue';
import AdaugaFactura_Iesire from '../facturare_components/AdaugaFactura_Iesire.vue';

export default {
  name: 'FacturiEmise',
  components: { Multiselect, IncasareModal, AdaugaFactura_Iesire },
  props: {
    firmaId: { type: [Number, String], required: true }
  },
  data() {
    return {
      facturi: [],
      selectedRowIds: [],
      expandedRows: [],
      produseCache: {},     // { [facturaId]: rows[] }
      childApps: {},        // { [facturaId]: appInstance }
      dtInstance: null,     // DataTables instance (v1 sau v2)
      dtInitializing: false,
      efactPopup: { visible: false, title: '', message: '' },
      rjModalVisible: false,
      rjLoading: false,
      rjSaving: false,
      modalFactura: null,
      modalProduse: [],
      modalLoading: false,
      useAutoRJ: true,
      rjForm: {
        id_firma: null,
        id_firma: null,
        id_document: null,
        tip_document: 'Factura',
        id_tip_document: null,
        serie_doc: '',
        nr_doc: '',
        data_doc: '',
        moneda: 'RON',
        curs: 1,
        perioada_contabila: '',
        id_client: null,
        valoare_baza: 0,
        valoare_tva: 0,
        valoare_total: 0,
        observatii: '',
        cont_venit: '707',
        cont_tva: '4427',
      },
      liniiRJ: [],
      rjErrors: [],
      rjExists: false,
      contClientCod: null, // codul contului client din plan_conturi (ex: 4111.500)
      tipuriDocument: [], // Added for Multiselect
      // Tooltip custom
      tooltipData: {
        visible: false,
        text: '',
        activeId: null
      },
      backendPreviewLines: [],
      incasareModal: {
        visible: false,
        factura: null,
        clientId: null // furnizorId in plati context, clientId here
      },

      // Factura Editor state
      editMode: false,
      showFacturaEditor: false,
      filePreview: null,
      facturaForm: {
        id: null,
        serie_document: null,
        serie_document_obj: null,
        nr_document: '',
        data_emitere: '',
        termen_plata: '',
        client: null,
        client_obj: null,
        valuta: 'RON',
        valuta_obj: null,
        curs_valutar: 1,
        delegat_nume: '',
        delegat_date: '',
        delegat_auto: '',
        intocmit_de: '',
        intocmit_cnp: '',
        informatii_suplimentare: '',
        sold: 0,
      },
      facturaProduse: [],

      // Utils for editor
      seriiFacturi: [],
      listaClienti: [],
      valute: [],
      unitatiMasura: [],
      tipuriProduse: [],
      coteTva: [],
      planConturi: [],
      facturaUtilsLoaded: false,
      facturaUtilsLoading: false,
    };
  },
  computed: {
    selectAllVisibleChecked() {
      if (!Array.isArray(this.facturi) || this.facturi.length === 0) return false;
      const visibleIds = this.facturi.map(r => r.id);
      return visibleIds.every(id => this.selectedRowIds.includes(id));
    },
    tipDocObj: {
      get() {
        if (!this.rjForm.id_tip_document && !this.rjForm.tip_document) return null;
        if (this.rjForm.id_tip_document) {
          return this.tipuriDocument.find(t => t.id === this.rjForm.id_tip_document) || null;
        }
        // Fallback by name
        return this.tipuriDocument.find(t => t.descriere === this.rjForm.tip_document) || null;
      },
      set(val) {
        if (val) {
          this.rjForm.id_tip_document = val.id;
          this.rjForm.tip_document = val.descriere;
        } else {
          this.rjForm.id_tip_document = null;
          this.rjForm.tip_document = 'Factura';
        }
      }
    },
    autoPreviewLines() {
      // 1) Backend Preview (Smart Split)
      if (this.backendPreviewLines && this.backendPreviewLines.length > 0) {
        return this.backendPreviewLines.map(l => ({
          debit: l.cont_debit_cod_complet || l.cont_debit_id,
          credit: l.cont_credit_cod_complet || l.cont_credit_id,
          suma: Number(l.suma_ron || 0),
          explicatie: l.descriere
        }));
      }

      // 2) Fallback Legacy
      if (!this.useAutoRJ || !this.modalFactura) return [];
      const baza = Number(this.rjForm.valoare_baza || this.modalFactura.iesiri_date_valoare || 0);
      const tva = Number(this.rjForm.valoare_tva || this.modalFactura.iesiri_date_tva || 0);
      const idClient = this.rjForm.id_client || this.modalFactura.id_client || null;
      // Folosim contul existent din plan_conturi (dacă există), altfel fallback la 4111.{id_client}
      const contClient = this.contClientCod || (idClient ? `4111.${idClient}` : '4111');

      const lines = [];
      if (baza > 0) {
        lines.push({
          debit: contClient,
          credit: this.rjForm.cont_venit || '707',
          suma: baza,
          explicatie: 'Venit (bază) ' + (this.rjForm.tip_document || ''),
        });
      }
      if (tva > 0) {
        lines.push({
          debit: contClient,
          credit: this.rjForm.cont_tva || '4427',
          suma: tva,
          explicatie: 'TVA colectată (4427)',
        });
      }
      return lines;
    },
  },
  watch: {
    firmaId: {
      immediate: true,
      handler() {
        this.loadFacturi();
      }
    }
  },
  mounted() {
    this.incarcaTipDocument();
  },
  beforeUnmount() {
    this.destroyDT();
    // unmount orice child apps rămase
    Object.values(this.childApps).forEach(app => { try { app.unmount(); } catch { } });
    this.childApps = {};
  },
  methods: {
    // ===== Helpers =====
    ensureDTReady(cb, attempt = 0) {
      const MAX = 10;
      const $ = window.jQuery || window.$;
      const ready = ($ && $.fn && ($.fn.DataTable || $.fn.dataTable)) || (typeof window !== 'undefined' && window.DataTable);
      if (ready) { cb($); return; }
      if (attempt >= MAX) { console.warn('DataTables not available after wait'); return; }
      setTimeout(() => this.ensureDTReady(cb, attempt + 1), 50);
    },
    incarcaTipDocument() {
      axios.get('/api/administrare/work/utils/tipuri-documente', { params: { tip: 2 } })
        .then(r => {
          this.tipuriDocument = r.data || [];
        })
        .catch(e => console.error("Error fetching doc types:", e));
    },
    destroyDT() {
      if (this.dtInstance && typeof this.dtInstance.destroy === 'function') {
        try { this.dtInstance.destroy(); } catch { }
      }
      this.dtInstance = null;
    },
    formatDate(d) {
      if (!d) return '';
      try { return new Date(d).toLocaleDateString('ro-RO'); } catch { return ''; }
    },
    formatMoney(v) {
      const n = Number(v || 0);
      return n.toLocaleString('ro-RO', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' lei';
    },
    isSelected(id) {
      return this.selectedRowIds.includes(id);
    },
    onToggleSelect(id, ev) {
      const checked = !!(ev && ev.target && ev.target.checked);
      const idx = this.selectedRowIds.indexOf(id);
      if (checked && idx === -1) this.selectedRowIds.push(id);
      if (!checked && idx !== -1) this.selectedRowIds.splice(idx, 1);
    },
    onToggleSelectAllVisible(ev) {
      const checked = !!(ev && ev.target && ev.target.checked);
      const visibleIds = (this.facturi || []).map(r => r.id);
      if (checked) {
        this.selectedRowIds = Array.from(new Set([...this.selectedRowIds, ...visibleIds]));
      } else {
        this.selectedRowIds = this.selectedRowIds.filter(id => !visibleIds.includes(id));
      }
    },
    // ===== Data loading =====
    async loadFacturi() {
      if (!this.firmaId) return;
      try {
        const res = await axios.get('/api/administrare/work/incarcaFacturiEmise', { params: { firma_id: this.firmaId } });
        this.facturi = Array.isArray(res.data) ? res.data : (res.data.facturi || []);

        $(document).ready(() => {
          const $tbl = $('#tabel_facturare');
          try { $tbl.DataTable().destroy(); } catch { }

          $.fn.dataTable.ext.type.order['date-eu-pre'] = function (date) {
            if (!date) return 0;
            const parts = date.split('.');
            return Date.parse(`${parts[2]}-${parts[1]}-${parts[0]}`); // YYYY-MM-DD
          };

          const vm = this;
          $tbl.DataTable({
            pageLength: 15,
            lengthChange: false,
            columnDefs: [
              { targets: 0, responsivePriority: 1 },
              { targets: 3, type: 'date-eu' } // coloana "Data" (shifted from 2 to 3)
            ],
            order: [[3, 'desc']], // sortează după "Data" (shifted from 2 to 3)
            buttons: ['disable'],
            language: { url: 'https://cdn.datatables.net/plug-ins/1.11.3/i18n/ro.json' },
            paging: true,
            ordering: true,
            info: true,
            searching: true,
            responsive: false,
            autoWidth: false,
            //scrollX: true,
            createdRow: function (row, data, dataIndex) {
              const factura = vm.facturi[dataIndex];
              if (factura && factura.id) {
                $(row).addClass(`row-factura-${factura.id}`);
              } else {
                console.warn('Factura ID not found for dataIndex:', dataIndex, data);
              }
            }
          });

          // Click-ul pe expandare este gestionat prin Vue (@click in template)
        });
      } catch (e) {
        console.error('Eroare la încărcarea facturilor emise:', e);
        this.facturi = [];
        $(document).ready(() => {
          const $tbl = $('#tabel_facturare');
          try { $tbl.DataTable().destroy(); } catch { }
          $tbl.DataTable({ responsive: false });
        });
      }
    },
    initDT() {
      // no-op: DataTable este inițializat direct în loadFacturi(), similar cu componenta Intrari
    },
    // ===== Child row =====
    async incarcaProduseFactura(id) {
      try {
        const response = await axios.get(`/api/administrare/work/incarcaFacturiEmise/${id}`);
        const data = Array.isArray(response.data)
          ? response.data
          : (response.data?.produse || response.data?.items || response.data?.rows || []);
        this.produseCache = { ...this.produseCache, [id]: data };
        return data;
      } catch (error) {
        console.error(`Eroare la încărcarea produselor pentru factura ${id}:`, error);
        this.produseCache = { ...this.produseCache, [id]: [] };
        return [];
      }
    },
    // ===== Incasare =====
    deschideIncasare(factura) {
      if (!factura) return;
      this.incasareModal.factura = factura;
      this.incasareModal.clientId = factura.id_client;
      this.incasareModal.visible = true;
    },
    toggleFacturaDetails(factura) {
      const $ = window.jQuery || window.$;
      const table = $ && $.fn && $.fn.DataTable ? $('#tabel_facturare').DataTable() : null;
      if (!table) return;
      const tr = $(`.row-factura-${factura.id}`);
      const row = table.row(tr);

      if (row.child.isShown()) {
        row.child.hide();
        tr.removeClass('shown');
        this.expandedRows = this.expandedRows.filter(id => id !== factura.id);
        const inst = this.childApps[factura.id];
        if (inst && typeof inst.unmount === 'function') {
          try { inst.unmount(); } catch { }
        }
        delete this.childApps[factura.id];
        return;
      }

      const mountChild = (items) => {
        const wrapper = document.createElement('div');
        const app = createApp(FacturaChild, { factura, produse: items || [] });
        app.mount(wrapper);
        this.childApps[factura.id] = app;
        row.child(wrapper).show();
        tr.addClass('shown');
        if (!this.expandedRows.includes(factura.id)) this.expandedRows.push(factura.id);
      };

      row.child('<div class="p-3 text-muted">Se încarcă produsele...</div>').show();
      tr.addClass('shown');

      if (this.produseCache[factura.id]) {
        mountChild(this.produseCache[factura.id]);
      } else {
        this.incarcaProduseFactura(factura.id).then(() => {
          const items = this.produseCache[factura.id] || [];
          mountChild(items);
        });
      }
    },
    // ===== Registru Jurnal - Facturi emise =====
    prefillRJFormFromFactura(factura) {
      if (!factura) return;
      const baza = Number(factura.iesiri_date_valoare || 0);
      const tva = Number(factura.iesiri_date_tva || 0);
      const total = Number(factura.iesiri_date_total || (baza + tva));
      const idClient = factura.id_client || null;
      const contClient = idClient ? `4111.${idClient}` : '4111';

      const perioada =
        factura.data_doc && factura.data_doc.toString().length >= 7
          ? factura.data_doc.toString().slice(0, 7)
          : '';

      this.rjForm = {
        ...this.rjForm,
        id_firma: Number(this.firmaId) || null,
        id_document: factura.id,
        tip_document: 'Factura',
        serie_doc: factura.sd_serie || factura.serie_doc || '',
        nr_doc: factura.nr_doc || '',
        data_doc: factura.data_doc || '',
        moneda: this.rjForm.moneda || 'RON',
        curs: this.rjForm.curs || 1,
        perioada_contabila: this.rjForm.perioada_contabila || perioada,
        id_client: idClient,
        valoare_baza: baza,
        valoare_tva: tva,
        valoare_total: total,
        observatii: this.rjForm.observatii || '',
        cont_venit: '707',
        cont_tva: '4427',
      };

      this.liniiRJ = [];
      if (this.backendPreviewLines && this.backendPreviewLines.length > 0) {
        this.liniiRJ = this.backendPreviewLines.map(l => ({
          cont_debit: l.cont_debit_cod_complet || l.cont_debit_id,
          cont_credit: l.cont_credit_cod_complet || l.cont_credit_id,
          suma: Number(l.suma_ron || 0),
          explicatie: l.descriere || ''
        }));
        return;
      }

      // Fallback manual lines
      if (baza > 0) {
        this.liniiRJ.push({
          cont_debit: contClient,
          cont_credit: '707',
          suma: baza,
          explicatie: 'Venit (bază)' // + (this.rjForm.tip_document || ''),
        });
      }
      if (tva > 0) {
        this.liniiRJ.push({
          cont_debit: contClient,
          cont_credit: '4427',
          suma: tva,
          explicatie: 'TVA colectată'
        });
      }
    },
    async openRJModal(factura, startInEditMode = false) {
      this.editMode = !!startInEditMode;
      this.rjExists = false;
      this.liniiRJ = [];
      this.modalFactura = factura || null;
      this.rjLoading = true;
      this.rjSaving = false;
      this.rjErrors = [];
      this.useAutoRJ = true;
      this.modalProduse = [];
      this.modalLoading = false;
      this.filePreview = null;

      // Fetch file preview (non-blocking)
      if (factura?.id) {
        axios.get(`/api/administrare/work/facturi/fisier-preview/iesire/${factura.id}`, {
          params: { firma_id: this.firmaId }
        }).then(res => {
          if (res.data?.status === 'found') {
            this.filePreview = res.data;
          }
        }).catch(() => { /* silent */ });
      }

      // deschidem modalul Bootstrap (ca la FacturiPrimite)
      const id = 'lucruModalFacturiEmise';
      if (window.bootstrap && window.bootstrap.Modal) {
        const modalEl = document.getElementById(id);
        if (modalEl) {
          const instance = window.bootstrap.Modal.getOrCreateInstance(modalEl);
          instance.show();
        }
      } else if (window.$ && window.$.fn && window.$.fn.modal) {
        window.$('#' + id).modal('show');
      }

      if (factura) {
        this.prefillRJFormFromFactura(factura);
        // încărcăm produsele pentru afișare în partea stângă (Produse)
        try {
          const items = await this.incarcaProduseFactura(factura.id);
          this.modalProduse = Array.isArray(items) ? items : [];
        } catch (e) {
          console.error('Eroare la încărcarea produselor pentru RJ factură emisă:', e);
          this.modalProduse = [];
        } finally {
          this.modalLoading = false;
        }
      }

      try {
        const res = await axios.get('/api/administrare/work/reg-jurnal/factura-emisa', {
          params: {
            firma_id: this.firmaId,
            document_id: factura.id,
            tip_document: 'Factura',
          },
        });

        if (res.data && res.data.exists) {
          this.rjExists = true;

          const antet = res.data.antet || {};
          this.rjForm = {
            ...this.rjForm,
            id_firma: antet.id_firma || Number(this.firmaId) || null,
            id_document: antet.id_document || factura.id,
            tip_document: antet.tip_document || 'Factura',
            id_tip_document: antet.id_tip_document || null,
            serie_doc: antet.doc_serie || this.rjForm.serie_doc,
            nr_doc: antet.doc_numar || this.rjForm.nr_doc,
            data_doc: antet.doc_data || this.rjForm.data_doc,
            moneda: antet.moneda || this.rjForm.moneda,
            curs: antet.curs || this.rjForm.curs,
            perioada_contabila: antet.perioada_contabila || this.rjForm.perioada_contabila,
            valoare_baza: antet.valoare_baza !== undefined ? Number(antet.valoare_baza) : this.rjForm.valoare_baza,
            valoare_tva: antet.valoare_tva !== undefined ? Number(antet.valoare_tva) : this.rjForm.valoare_tva,
            valoare_total: antet.valoare_total !== undefined ? Number(antet.valoare_total) : this.rjForm.valoare_total,
            observatii: antet.observatii || this.rjForm.observatii,
          };

          const linii = Array.isArray(res.data.linii) ? res.data.linii : [];
          this.liniiRJ = linii.map(l => ({
            cont_debit: l.cont_debit || '',
            cont_credit: l.cont_credit || '',
            suma: Number(l.suma || 0),
            explicatie: l.explicatie || '',
          }));
          this.useAutoRJ = this.liniiRJ.length === 0;
        } else {
          this.rjExists = false;
          this.useAutoRJ = true;
          this.liniiRJ = [];
          // Preluăm contul client existent din plan_conturi (dacă există)
          this.contClientCod = res.data.cont_client_cod || null;
          // Preluăm linii preview
          this.backendPreviewLines = res.data.linii_preview || [];

          this.prefillRJFormFromFactura(factura);
        }
      } catch (e) {
        console.error('Eroare la încărcarea RJ pentru factura emisă:', e);
        this.rjErrors.push('A apărut o eroare la încărcarea datelor din registru jurnal.');
        this.useAutoRJ = true;
        this.rjExists = false;
      } finally {
        this.rjLoading = false;
      }

      // If starting in edit mode, load editor data
      if (startInEditMode && factura?.id) {
        this.activateEditMode()
      }
    },

    async activateEditMode() {
      this.editMode = true
      const factura = this.modalFactura
      if (!factura || !factura.id) return

      this.facturaUtilsLoading = true
      try {
        if (!this.facturaUtilsLoaded) {
          await this.loadFacturaUtils()
        }

        const { data } = await axios.get(`/api/administrare/work/facturi/iesire/detalii/${factura.id}`, {
          params: { firma_id: this.firmaId }
        })
        if (data.status === 'success') {
          const f = data.factura
          this.facturaForm = {
            id: f.id,
            serie_document: f.serie_doc,
            serie_document_obj: this.seriiFacturi.find(s => s.text === f.serie_doc),
            nr_document: f.nr_doc,
            data_emitere: f.data_doc,
            termen_plata: f.data_scadenta,
            client: f.id_client != null ? Number(f.id_client) : null,
            client_obj: this.listaClienti.find(c => Number(c.id) === Number(f.id_client)) || null,
            valuta: f.id_valuta || 'RON',
            valuta_obj: this.valute.find(v => v.id === f.id_valuta),
            curs_valutar: f.curs || 1,
            delegat_nume: f.delegat,
            delegat_date: f.delegat_cnp,
            delegat_auto: f.delegat_auto,
            intocmit_de: f.nume,
            intocmit_cnp: f.cnp,
            informatii_suplimentare: f.informatii_suplimentare,
            sold: f.sold || 0
          }
          this.facturaProduse = data.produse.map(p => ({
            id: p.id,
            pozitie: p.pozitie,
            tip: p.tip_stoc,
            id_produs: p.id_produs,
            denumire: p.denumire,
            cota_tva: p.cota_tva,
            um: p.unitate_masura,
            cantitate: p.cantitate,
            pret: p.pret_unitar,
            valoare: p.valoare,
            valoare_tva: p.tva,
            total: p.total,
            cont_credit: p.cont_credit
          }))
        }
      } catch (e) {
        console.error('Error loading editor data:', e)
        this.$swal.fire('Eroare', 'Nu s-au putut încărca detaliile facturii pentru editare.', 'error')
        this.editMode = false
      } finally {
        this.facturaUtilsLoading = false
      }
    },
    closeRJModal() {
      // închidem modalul Bootstrap
      const id = 'lucruModalFacturiEmise';
      if (window.bootstrap && window.bootstrap.Modal) {
        const modalEl = document.getElementById(id);
        if (modalEl) {
          const instance = window.bootstrap.Modal.getInstance(modalEl);
          if (instance) instance.hide();
        }
      } else if (window.$ && window.$.fn && window.$.fn.modal) {
        window.$('#' + id).modal('hide');
      }

      // resetăm state-ul local
      this.rjModalVisible = false;
      this.modalFactura = null;
      this.rjExists = false;
      this.liniiRJ = [];
      this.rjErrors = [];
      this.rjLoading = false;
      this.rjSaving = false;
      this.modalProduse = [];
      this.modalLoading = false;
      this.contClientCod = null;
    },
    // ===== Helpers produse pentru modal RJ =====
    productName(p) {
      if (!p) return '-';
      return (
        p.denumire ||
        p.p_denumire ||
        p.produs_denumire ||
        p.nume_produs ||
        '-'
      );
    },
    productQty(p) {
      if (!p) return '';
      const q = p.cantitate ?? p.cant ?? p.qty ?? p.cant_fact ?? 0;
      return Number(q || 0).toLocaleString('ro-RO', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    productPrice(p) {
      if (!p) return '';
      const v = p.pret ?? p.pret_unitar ?? p.pu ?? p.pret_vanzare ?? 0;
      return this.formatMoney(v);
    },
    productValue(p) {
      if (!p) return '';
      const v =
        p.valoare ??
        p.valoare_fara_tva ??
        p.total_fara_tva ??
        p.suma_fara_tva ??
        0;
      return this.formatMoney(v);
    },
    productTva(p) {
      if (!p) return '';
      const v = p.tva ?? p.valoare_tva ?? p.suma_tva ?? 0;
      return this.formatMoney(v);
    },
    productTotal(p) {
      if (!p) return '';
      const v =
        p.total ??
        p.total_cu_tva ??
        p.valoare_cu_tva ??
        (p.valoare || 0) + (p.tva || 0);
      return this.formatMoney(v);
    },
    resetRJ() {
      this.rjErrors = [];
      if (this.modalFactura) {
        this.prefillRJFormFromFactura(this.modalFactura);
      } else {
        this.rjForm.valoare_baza = 0;
        this.rjForm.valoare_tva = 0;
        this.rjForm.valoare_total = 0;
        this.liniiRJ = [];
      }
    },
    async submitRJ() {
      if (!this.modalFactura) return;
      this.rjErrors = [];
      const errs = [];

      if (!this.useAutoRJ) {
        if (!Array.isArray(this.liniiRJ) || this.liniiRJ.length === 0) {
          errs.push('Adaugă cel puțin o linie contabilă.');
        } else {
          const invalid = this.liniiRJ.find(
            l => !l || !(Number(l.suma) > 0) || (!l.cont_debit && !l.cont_credit),
          );
          if (invalid) {
            errs.push(
              'Toate liniile trebuie să aibă cel puțin un cont (debit sau credit) și o sumă > 0.',
            );
          }
          const sumD = this.liniiRJ.reduce(
            (a, l) => a + (l.cont_debit ? Number(l.suma) || 0 : 0),
            0,
          );
          const sumC = this.liniiRJ.reduce(
            (a, l) => a + (l.cont_credit ? Number(l.suma) || 0 : 0),
            0,
          );
          if (+sumD.toFixed(2) !== +sumC.toFixed(2)) {
            errs.push(`Balanța liniilor nu este egală (D ${sumD.toFixed(2)} ≠ C ${sumC.toFixed(2)}).`);
          }

          const tvaFromLines = this.liniiRJ
            .filter(
              l =>
                typeof l.cont_credit === 'string' &&
                l.cont_credit.trim().startsWith('4427'),
            )
            .reduce((a, l) => a + (Number(l.suma) || 0), 0);
          const sumCredit = this.liniiRJ.reduce(
            (a, l) => a + (l.cont_credit ? Number(l.suma) || 0 : 0),
            0,
          );
          const bazaFromLines = sumCredit - tvaFromLines;
          const totalFromLines = sumCredit;

          this.rjForm.valoare_baza = bazaFromLines;
          this.rjForm.valoare_tva = tvaFromLines;
          this.rjForm.valoare_total = totalFromLines;
        }
      } else {
        const baza =
          this.rjForm.valoare_baza ||
          this.modalFactura.iesiri_date_valoare ||
          0;
        const tva =
          this.rjForm.valoare_tva ||
          this.modalFactura.iesiri_date_tva ||
          0;
        const tot =
          this.rjForm.valoare_total ||
          this.modalFactura.iesiri_date_total ||
          baza + tva;

        this.rjForm.valoare_baza = Number(baza);
        this.rjForm.valoare_tva = Number(tva);
        this.rjForm.valoare_total = Number(tot);

        if (!this.rjForm.id_client && !this.modalFactura.id_client) {
          errs.push('Nu există client asociat facturii (id_client). Nu se poate posta automat.');
        }
      }

      if (errs.length) {
        this.rjErrors = errs;
        return;
      }

      const antetPayload = {
        id_firma: Number(this.firmaId),
        id_document: this.modalFactura.id,
        tip_document: this.rjForm.tip_document || 'Factura',
        id_tip_document: this.rjForm.id_tip_document || null,
        serie_doc: this.rjForm.serie_doc || this.modalFactura.sd_serie || '',
        nr_doc: this.rjForm.nr_doc || this.modalFactura.nr_doc || '',
        data_doc: this.rjForm.data_doc || this.modalFactura.data_doc || '',
        moneda: this.rjForm.moneda || 'RON',
        curs: this.rjForm.curs || 1,
        perioada_contabila:
          this.rjForm.perioada_contabila ||
          (this.modalFactura.data_doc
            ? this.modalFactura.data_doc.toString().slice(0, 7)
            : ''),
        id_client: this.rjForm.id_client || this.modalFactura.id_client || null,
        valoare_baza: Number(this.rjForm.valoare_baza || 0),
        valoare_tva: Number(this.rjForm.valoare_tva || 0),
        valoare_total: Number(this.rjForm.valoare_total || 0),
        observatii: this.rjForm.observatii || '',
        cont_venit: this.rjForm.cont_venit || '707',
        cont_tva: this.rjForm.cont_tva || '4427',
      };

      const payload = {
        auto: this.useAutoRJ,
        antet: antetPayload,
      };

      if (!this.useAutoRJ) {
        payload.linii = this.liniiRJ
          .filter(
            l => l && Number(l.suma) > 0 && (l.cont_debit || l.cont_credit),
          )
          .map(l => ({
            cont_debit: l.cont_debit ? String(l.cont_debit).trim() : null,
            cont_credit: l.cont_credit ? String(l.cont_credit).trim() : null,
            suma: Number(l.suma),
            explicatie: l.explicatie ? String(l.explicatie).trim() : '',
          }));
      }

      this.rjSaving = true;
      try {
        const resp = await axios.post(
          '/api/administrare/work/reg-jurnal/factura-emisa/save',
          payload,
        );
        console.log('RJ factură emisă salvat:', resp.data);
        this.closeRJModal();
        // Refresh tabelul pentru a actualiza coloana RJ
        this.loadFacturi();
      } catch (e) {
        console.error('Eroare la salvarea RJ pentru factura emisă:', e);
        const msg =
          (e.response && e.response.data && e.response.data.error) ||
          'A apărut o eroare la salvare.';
        this.rjErrors = [msg];
      } finally {
        this.rjSaving = false;
      }
    },
    // ===== e-Fact popup helpers =====
    buildObsPrettyHtml(str) {
      const txt = (str || '').toString();
      const escaped = txt.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
      return `<pre class="mb-0" style="white-space:pre-wrap">${escaped}</pre>`;
    },
    showEFactPopup(factura, tip) {
      try {
        const statusLabel = this.eFactStatusBarLabel(factura.anaf_ft_status);
        const uploadLabel = this.eFactUploadBarLabel(factura.anaf_ft_stare_upload);
        const obsStatusRaw = (factura.anaf_ft_obs || '').toString().trim();
        const obsUploadRaw = (factura.anaf_ft_obs_upload || '').toString().trim();

        let title = 'Detalii e-Factura';
        let message = '';

        if (tip === 'upload') {
          title = `Upload e-Factură — ${uploadLabel}`;
          message = obsUploadRaw ? this.buildObsPrettyHtml(obsUploadRaw) : '<p>Nu există observații pentru upload.</p>';
        } else {
          title = `Status e-Factură — ${statusLabel}`;
          if (obsStatusRaw) {
            message = this.buildObsPrettyHtml(obsStatusRaw);
          } else {
            switch (Number(factura.anaf_ft_status)) {
              case 1: message = '<p>Factura este marcată ca <strong>Transmisă</strong> către e-Factura.</p>'; break;
              case 2: message = '<p><strong>Eroare la trimitere.</strong> Puteți reîncerca.</p>'; break;
              case 3: message = '<p><strong>Eroare de validare XML.</strong> Corectați și reîncercați.</p>'; break;
              default: message = '<p>Factura nu a fost transmisă către e-Factura.</p>'; break;
            }
          }
        }

        this.efactPopup.title = title;
        this.efactPopup.message = message;
        this.efactPopup.visible = true;
      } catch (e) {
        console.error('showEFactPopup error:', e);
        this.efactPopup.title = 'Detalii e-Factura';
        this.efactPopup.message = 'A apărut o eroare la afișarea mesajului.';
        this.efactPopup.visible = true;
      }
    },
    eFactUploadBarLabel(code) {
      switch (Number(code)) {
        case 1: return 'Finalizat';
        case 2: return 'NOK';
        case 3: return 'Prelucrare';
        default: return 'Incarcata';
      }
    },
    eFactUploadBarClass(code) {
      switch (Number(code)) {
        case 1: return 'bg-success';
        case 2: return 'bg-danger';
        case 3: return 'bg-primary';
        default: return 'bg-info';
      }
    },
    eFactStatusBarLabel(code) {
      switch (Number(code)) {
        case 1: return 'Transmis';
        case 2: return 'Eroare trimitere';
        case 3: return 'Eroare XML';
        default: return 'Netransmis';
      }
    },
    eFactStatusBarClass(code) {
      switch (Number(code)) {
        case 1: return 'bg-primary';
        case 2: return 'bg-danger';
        case 3: return 'bg-warning';
        default: return 'bg-secondary';
      }
    },
    showFullName(text, id) {
      if (!text || text === '-' || text === '/') return;

      if (this.tooltipData.visible && this.tooltipData.activeId === id) {
        this.tooltipData.visible = false;
        this.tooltipData.activeId = null;
        return;
      }

      this.tooltipData.text = text;
      this.tooltipData.activeId = id;
      this.tooltipData.visible = true;

      const closeHandler = () => {
        this.tooltipData.visible = false;
        this.tooltipData.activeId = null;
        document.removeEventListener('click', closeHandler);
      };
      setTimeout(() => document.addEventListener('click', closeHandler), 10);
    },

    async loadFacturaUtils() {
      if (this.facturaUtilsLoaded) return;
      this.facturaUtilsLoading = true;
      try {
        const idFirma = this.firmaId;
        const [resSerii, resClienti, resValute, resUM, resTipuri, resCote, resPlan] = await Promise.all([
          axios.get(`/api/administrare/work/utils/serii-facturi/${idFirma}`),
          axios.get(`/api/administrare/work/utils/clienti/${idFirma}`),
          axios.get('/api/administrare/work/utils/valute'),
          axios.get('/api/administrare/work/utils/unitati-masura'),
          axios.get('/api/administrare/work/utils/tipuri-produse'),
          axios.get('/api/administrare/work/utils/cote-tva'),
          axios.get(`/api/administrare/work/utils/plan-conturi/${idFirma}`)
        ]);

        this.seriiFacturi = resSerii.data || [];
        this.listaClienti = resClienti.data || [];
        this.valute = resValute.data || [];
        this.unitatiMasura = resUM.data || [];
        this.tipuriProduse = resTipuri.data || [];
        this.coteTva = resCote.data || [];
        this.planConturi = resPlan.data || [];

        this.facturaUtilsLoaded = true;
      } catch (e) {
        console.error('Error loading factura utils:', e);
        this.$swal.fire({
          icon: 'error',
          title: 'Eroare',
          text: 'Nu s-au putut încărca utilitarele de facturare.',
        });
      } finally {
        this.facturaUtilsLoading = false;
      }
    },

    async stergeFactura(factura) {
      if (!factura || !factura.id) return;

      const result = await this.$swal.fire({
        title: 'Ești sigur?',
        html: `<p>Factura <b>${factura.serie_doc || ''}${factura.nr_doc || ''}</b> va fi ștearsă definitiv.</p>
               <p class="text-danger fw-bold">Această acțiune este ireversibilă!</p>
               <p class="text-muted small">Se vor șterge: factura, produsele, totalurile, înregistrările din Registrul Jurnal și repartizările de încasări.<br>Fișierul sursă (imaginea) <b>nu</b> va fi șters.</p>`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#6c757d',
        confirmButtonText: 'Da, șterge factura!',
        cancelButtonText: 'Anulează',
        reverseButtons: true,
      });

      if (!result.isConfirmed) return;

      try {
        const res = await axios.delete(
          `/api/administrare/work/facturi/iesire/sterge/${factura.id}`,
          { params: { firma_id: this.firmaId } }
        );

        if (res.data.status === 'success') {
          this.$swal.fire({
            icon: 'success',
            title: 'Factură ștearsă!',
            showConfirmButton: false,
            timer: 1500,
          });
          this.loadFacturi();
        } else {
          this.$swal.fire('Eroare', res.data.message || 'Nu s-a putut șterge factura.', 'error');
        }
      } catch (e) {
        console.error('Error deleting invoice:', e);
        this.$swal.fire('Eroare', e.response?.data?.message || 'Nu s-a putut șterge factura.', 'error');
      }
    },

    async salveazaFacturaActualizata() {
      if (!this.facturaForm.id) return;

      this.facturaUtilsLoading = true;
      try {
        const payload = {
          firma_id: this.firmaId,
          factura: this.facturaForm,
          produse: this.facturaProduse,
        };

        const res = await axios.put(
          `/api/administrare/work/facturi/iesire/actualizeaza/${this.facturaForm.id}`,
          payload,
        );

        if (res.data.status === 'success') {
          this.$swal.fire({
            icon: 'success',
            title: 'Factură actualizată!',
            showConfirmButton: false,
            timer: 1500,
          });
          this.editMode = false;
          this.loadFacturi();
          if (this.modalFactura) {
            this.$nextTick(() => {
              const updated = this.facturi.find(f => f.id === this.facturaForm.id);
              if (updated) {
                this.modalFactura = updated;
              }
            });
          }
        }
      } catch (e) {
        console.error('Error updating invoice:', e);
        this.$swal.fire('Eroare', e.response?.data?.message || 'Nu s-a putut actualiza factura.', 'error');
      } finally {
        this.facturaUtilsLoading = false;
      }
    },
  }
};
</script>

<style scoped>
/* full width table */
#tabel_facturare {
  width: 100% !important;
}

/* basic modal, adaptă la tema ta */
.modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, .35);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.modal-card {
  background: #fff;
  border-radius: 10px;
  width: min(1100px, 96vw);
  /* aliniat ca dimensiune cu modalul de la facturi primite */
  max-height: 90vh;
  overflow: auto;
}

.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  border-bottom: 1px solid rgba(0, 0, 0, .06);
}

.modal-body {
  padding: 16px;
}

.btn-close {
  border: 0;
  background: transparent;
  font-size: 22px;
  line-height: 1;
  cursor: pointer;
}


.modal-products-scroll {
  max-height: 260px;
  overflow-y: auto;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.modal-products-scroll table {
  min-width: 900px;
  /* sau ajustează la nevoie, dar asigură overflow pe orizontală */
}

.modal-products-scroll table th {
  white-space: normal;
  /* Allow headers to wrap */
}

#lucruModalFacturiEmise .modal-dialog.modal-xxl-custom {
  max-width: 95vw;
  width: 95vw;
}


#tabel_facturare {
  width: 100% !important;
  min-width: 1200px;
}

#tabel_facturare thead th {
  white-space: normal;
  vertical-align: middle;
}

.text-truncate-clickable {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 300px;
  cursor: pointer;
  display: inline-block;
  vertical-align: middle;
}

.rotate-up {
  transform: rotate(180deg);
  transition: transform 0.2s;
}

/* Tooltip Finut Style - NESTED approach */
.custom-table-tooltip {
  position: absolute;
  bottom: 125%;
  /* Slight gap */
  left: 50%;
  transform: translateX(-50%);
  z-index: 9999;
  background: #2b2b2b;
  color: #fff;
  padding: 8px 14px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 500;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.4);
  width: max-content;
  max-width: 320px;
  text-align: center;
  line-height: 1.4;
  pointer-events: none;
  animation: tooltip-fade-in 0.15s ease-out forwards;
  will-change: opacity, transform;
}

.custom-table-tooltip::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -6px;
  border-width: 6px;
  border-style: solid;
  border-color: #2b2b2b transparent transparent transparent;
}

@keyframes tooltip-fade-in {
  from {
    opacity: 0;
    transform: translateX(-50%) translateY(4px);
  }

  to {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
  }
}
</style>
